import { FC, useState } from 'react'

import { Button } from '@forto-dev/phoenix-ui-core'

import { useLocalisation } from '@/utils/localisation'

import { CancelShipmentDialog } from './CancelShipmentDialog'

export type CancelShipmentRequestButtonProps = {
  houseShipmentID: string
  cargoReadyDate?: string
  contactPerson?: string
  origin?: string
  destination?: string
  quoteCode?: string | null
}

export const CancelShipmentRequestButton: FC<CancelShipmentRequestButtonProps> = (props) => {
  const { translate } = useLocalisation()
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button variant="outline-primary" onClick={() => setOpen(true)}>
        {translate('notifications.cancel_shipment.title')}
      </Button>
      <CancelShipmentDialog open={open} onOpenChange={setOpen} {...props} />
    </>
  )
}
